module.exports = __webpack_public_path__ + "img/ldv.e9647d53.png";